import React, { useState, useEffect } from 'react';
import { FooterTop } from './FooterTop';
import { FooterDisclaimers } from './FooterDisclaimers';
import { FooterAbout } from './FooterAbout';
import { FooterBottom } from './FooterBottom';

export const Footer: React.FC = () => {
    const [screenWidth, setScreenWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const getPaddingX = () => {
        if (screenWidth >= 1800) return '239px'; // Full padding for >= 1800px
        if (screenWidth >= 1200) return '119px'; // Half padding for >= 1200px
        return '60px';                          // Quarter padding for < 1200px (roughly)
    };

    return (
        <footer className="w-full bg-[#222222] rounded-none md:rounded-t-[32px]">
            <div 
                className="px-4 pt-8 md:pt-0"
                style={{
                    paddingLeft: screenWidth >= 768 ? getPaddingX() : '16px',
                    paddingRight: screenWidth >= 768 ? getPaddingX() : '16px',
                }}
            >
                {/* Top Section: Logo, Explore, Company */}
                <div className="px-0 md:pt-16 md:pb-0 md:px-20">
                    <FooterTop />
                </div>

                {/* Horizontal Divider */}
                <div className="pt-4 px-0 md:pt-16 md:px-20">
                    <div className="w-full h-[1px] bg-[#666666] block" style={{ backgroundColor: '#666666', height: '1px' }} />
                </div>

                {/* Middle Section: Disclaimers */}
                <div className="pt-16 pb-0 px-0 md:px-20">
                    <FooterDisclaimers />
                </div>

                {/* About Section: Brand Story */}
                <div className="pt-16 pb-0 px-0 md:px-20">
                    <FooterAbout />
                </div>

                {/* Horizontal Divider */}
                <div className="pt-16 px-0 md:px-20">
                    <div className="w-full h-[1px] bg-[#666666] block" style={{ backgroundColor: '#666666', height: '1px' }} />
                </div>

                {/* Bottom Section: Large ALYZE Logo */}
                <div className="pt-16 pb-0 px-0 md:px-20">
                    <FooterBottom />
                </div>
            </div>
        </footer>
    );
};
